export default __webpack_public_path__ + "static/media/genome-quebec.45011bb3.png";